import { render, staticRenderFns } from "./Profile.html?vue&type=template&id=3d7d823f&scoped=true&"
import script from "./Profile.js?vue&type=script&lang=js&"
export * from "./Profile.js?vue&type=script&lang=js&"
import style0 from "./Profile.scss?vue&type=style&index=0&id=3d7d823f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d823f",
  null
  
)

export default component.exports